const home = {
  home: {
    hero: {
      kicker: 'Premium real estate advisory',
      badge: 'Premium Properties',
      brandName: 'Safaqat 24',
      tagline: 'Your Trusted Real Estate Platform',
      description: 'Discover luxury properties in Saudi Arabia with expert guidance',
      title: 'Discover exceptional homes across the region',
      subtitle:
        'Safaqat 24 pairs curated listings with bespoke guidance to secure your next investment or residence with confidence.',
      search: {
        placeholder: 'Search by city, neighbourhood, or property ID',
        button: 'Search homes',
        // Rightmove-style hero search: Buy/Rent/Sold tabs + label + field
        tablistLabel: 'Search type',
        tabs: { buy: 'Buy', rent: 'Rent', sold: 'Sold' },
        soon: 'Soon',
        toBuy: 'Search properties to buy',
        toRent: 'Search properties to rent',
        soldLabel: 'Sold property prices - coming soon',
        soldHint: 'Sold-price search is coming soon. Pick Buy or Rent to search now.',
        fieldPlaceholder: 'Search city or district…',
        keywordPlaceholder: 'Add a keyword (optional)…',
        removeLocation: 'Remove location',
        searchBtn: 'Search',
        onMap: 'Search on the map',
        filters: 'Filters',
        propertyType: 'Property type',
        allTypes: 'All',
        residential: 'Residential',
        commercial: 'Commercial',
        categoryLabel: 'Property category: residential or commercial',
        bathrooms: 'Bathrooms',
        priceLabel: 'Price (SAR)',
        min: 'Min',
        max: 'Max',
        areaUnit: 'm²',
        quickLabel: 'Popular searches',
        suggestions: [
          'Jeddah luxury villas',
          'Jeddah skyline apartments',
          'Homes under 5M SAR',
          'Dammam waterfront rentals',
        ],
      },
      primaryCta: 'Browse listings',
      secondaryCta: 'Book a consultation',
    },
    location: {
      enableTitle: 'Enable Location',
      enableDescription: 'To show properties near you, we need access to your location',
      notNow: 'Not Now',
      allow: 'Allow',
      nearYou: 'Near You',
      propertiesIn: 'Properties in {{city}}',
      chooseType: "Choose what you're looking for: Rent or Buy",
      all: 'All',
      forRent: 'For Rent',
      forSale: 'For Sale',
      loading: 'Finding properties near you...',
    },
    stats: {
      total: 'Total listings',
      average: 'Average price',
      cities: 'Cities served',
    },
    featuresSection: {
      kicker: 'Why Safaqat 24',
      title: 'Everything you need in one place',
      description:
        'We combine smart analytics with real estate expertise to deliver tailored solutions for your investment and lifestyle needs.',
    },
    features: {
      discovery: {
        title: 'Tailored discovery',
        description:
          'Advanced analytics and on-the-ground expertise narrow options to the most suitable properties for you.',
      },
      advisory: {
        title: 'AI-powered search',
        description:
          'We leverage AI technology to analyze thousands of properties and deliver precise search results that match your requirements.',
      },
      experience: {
        title: 'AI market analysis',
        description:
          'We provide AI-driven market insights to help you understand pricing trends and make better investment decisions.',
      },
    },
    featured: {
      kicker: 'Featured listings',
      title: 'Homes our clients love',
      subtitle:
        'Explore a rotating selection of residences that balance architect-led design, coveted locations, and long-term value.',
      badge: 'View property',
      priceLabel: 'List price',
      pricePerSqm: 'Price per sqm',
      bedLabel: 'Bedrooms',
      bathLabel: 'Bathrooms',
      areaLabel: 'Interior area',
      sqmUnit: 'sqm',
      viewDetails: 'View details',
      exploreAll: 'Explore all listings',
      empty: 'New featured properties are being prepared; please check back shortly.',
      properties: {
        'ksa-riyadh-01': {
          title: 'Skyline villa overlooking Jeddah Park',
          city: 'Jeddah',
        },
        'ksa-jeddah-02': {
          title: 'Palm-framed seafront residence in Jeddah',
          city: 'Jeddah',
        },
        'ksa-dammam-03': {
          title: 'Contemporary family home in Dammam Heights',
          city: 'Dammam',
        },
      },
    },
    quickSearch: {
      label: 'Suggested quick searches',
    },
    testimonials: {
      kicker: 'Client stories',
      title: 'Trusted by discerning buyers and landlords',
      subtitle:
        'Our clients value our discretion, data-driven approach, and the results we deliver across premium markets.',
      items: [
        {
          name: 'Sarah Al-Mutairi',
          role: 'Investment client',
          quote:
            'Safaqat 24 curated investment-ready villas that matched my portfolio strategy. Their insight into emerging districts was invaluable.',
        },
        {
          name: 'Khaled Al-Rashid',
          role: 'Developer partner',
          quote:
            'The team positioned our launch flawlessly, from pricing intelligence to private previews for VIP buyers.',
        },
        {
          name: 'Layla Hassan',
          role: 'Corporate tenant',
          quote:
            'Fast, informed, and attentive. They negotiated flexible terms for our relocation and handled the full onboarding.',
        },
      ],
    },
    // ── 2026 on-brand homepage (direction 3a). All redesign strings live under
    //    `home.v2.*` so they never collide with the legacy keys above. ──────────
    v2: {
      strip: {
        servicesLabel: 'Our services',
        categoriesLabel: 'Browse by category',
        sell: 'Sell',
        buy: 'Buy',
        rent: 'Rent',
        invest: 'Invest',
        residential: 'Residential',
        commercial: 'Commercial',
        land: 'Land',
        investment: 'Investment',
      },
      hero: {
        boardTitle: 'Find your ideal property',
        // The animated headline: the sentence is fixed, only `cities` cycles.
        dealLead: 'Find the best property deal in',
        cities: ['Madinah', 'Riyadh', 'Jeddah', 'Makkah', 'Dammam', 'Khobar', 'Abha'],
        boardSubtitle: 'Apartments · Villas · Land · Commercial',
        tagline: 'Your property .. your best opportunity',
        promise: 'A trusted real-estate platform pairing opportunity with ease',
        badge: 'All listings are licensed & verified with REGA',
        liveListings: 'live listings',
        titleLead: 'Snag the best deal',
        titleAccent: 'life.',
        subtitle:
          'A trusted real-estate platform to buy, rent, and invest across the Kingdom, with licensed listings.',
        searchOnMap: 'Search on the map',
        popular: 'Popular',
        chips: {
          villasRiyadh: 'Villas in Riyadh',
          aptsJeddah: 'Apartments in Jeddah',
          offplanKhobar: 'Off-plan in Al Khobar',
          newProjects: 'New projects',
        },
        trust: {
          rega: 'Licensed by REGA',
          regaAuthority: 'الهيئة العامة للعقار',
          fal: 'FAL-verified brokers only',
          cities: '20+ cities across the Kingdom',
        },
      },
      browseType: {
        title: 'Browse by property type',
        subtitle: "Jump straight into the category you're after.",
        listings: '{{n}} listings',
        plots: '{{n}} plots',
        types: {
          apartment: 'Apartments',
          villa: 'Villas',
          land: 'Land',
          office: 'Offices',
          building: 'Buildings',
          rest_house: 'Rest houses',
        },
      },
      featured: {
        eyebrow: 'Handpicked this week',
        title: 'Featured properties',
        browseAll: 'Browse all properties',
        forSale: 'For Sale',
        forRent: 'For Rent',
        isNew: 'New',
        verified: 'Verified',
        // Compact listing card: screen-reader text beside the numbers.
        beds_one: '{{n}} bedroom',
        beds_other: '{{n}} bedrooms',
        baths_one: '{{n}} bathroom',
        baths_other: '{{n}} bathrooms',
        area: 'Area',
        // Rent period after the price ("/year"), shown only when the listing states it.
        period: { monthly: 'month', yearly: 'year', daily: 'day' },
      },
      cities: {
        title: 'Browse properties by city',
        subtitle: 'From the capital to the coast.',
        listings: '{{n}} listings',
        // Listing count on a city card.
        count_zero: 'No listings yet',
        count_one: '{{n}} listing',
        count_other: '{{n}} listings',
        names: { riyadh: 'Riyadh', jeddah: 'Jeddah', dammam: 'Dammam', makkah: 'Makkah', madinah: 'Madinah' },
      },
      actions: {
        list: {
          title: 'List your property',
          body: 'For owners: listing is free under the Safaqat 24 licence, with a 2.5% commission only when the deal completes.',
          cta: 'Start listing',
        },
        request: {
          title: 'Post a request',
          body: "Tell us what you're looking for and let licensed brokers bring the right homes to you.",
          cta: 'Find a home',
        },
        invest: {
          title: 'Invest with data',
          body: 'Price, rent and gross-yield ranges by district, from deals registered with the Ministry of Justice.',
          cta: 'Explore insights',
        },
      },
      // The home page's closing row: the account, professionals, advertiser plans.
      nextSteps: {
        title: 'More with Safaqat 24',
        account: {
          title: 'Create a free account',
          body: 'Save the homes you like, message advertisers and follow their replies in one place.',
          cta: 'Create your account',
        },
        favorites: {
          title: 'Your saved homes',
          body: "The homes you saved and the advertisers' replies to you, in one place.",
          cta: 'Open favourites',
        },
        professionals: {
          title: 'Find a real-estate professional',
          body: 'Licensed brokers, appraisers and property managers in your city, contacted directly.',
          cta: 'Browse professionals',
        },
        plans: {
          title: 'Plans for advertisers',
          body: 'For brokers, companies and developers: publish your listings, feature them and track their views.',
          cta: 'See the plans',
        },
      },
      why: {
        eyebrow: 'Why Safaqat 24',
        title: 'The trusted place to move in Saudi Arabia.',
        cta: 'Create free account',
        items: {
          verified: { title: 'Clear licensing', body: "We show the ad licence number and the advertiser's FAL licence when available, so you can check them yourself." },
          support: { title: 'Technical support', body: 'Bilingual specialists guide you from first search to signed contract.' },
          faster: { title: 'Search your way', body: 'Describe what you want in your own words, or draw your area on the map to see the properties inside it.' },
        },
        stats: {
          listings: 'published listings',
          listings_one: 'published listing',
          listings_other: 'published listings',
          brokers: 'licensed brokers',
          brokers_one: 'licensed broker',
          brokers_other: 'licensed brokers',
          cities: 'cities covered',
          cities_one: 'city covered',
          cities_other: 'cities covered',
        },
      },
      brokers: {
        eyebrow: 'Verified network',
        title: 'Trusted brokers across the Kingdom',
        subtitle: 'Explore REGA-licensed brokers and agencies by where they operate - then open the full interactive map.',
        viewMap: 'Explore the broker map',
        viewAll: 'View all brokers',
        listings: '{{n}} listings',
        empty: 'Broker profiles are being verified - check back shortly.',
      },
      projects: {
        eyebrow: 'Off-plan & new',
        title: 'Featured new projects',
        all: 'All developers',
        offplan: 'Off-plan',
        ready: 'Ready',
        units: '{{n}} units',
        empty: 'New developments are being prepared; check back shortly.',
      },
      listCta: {
        title: 'Ready to list? Put your property in front of the Kingdom.',
        body: 'Free to publish, licensed by REGA, and seen by thousands of verified buyers and tenants every day.',
        cta: 'List your property',
      },
    },
  },
};

export default home;

